import { Subject } from "rxjs";

import log2 from "./log2";

import app from "../store/modules/app";

const messages = new Subject();
const log = log2("SocketStream");
let socket = null;
export const addSocketMessage = (cmd, data) => {
    log.debug("addSocketMessage", { cmd, data });
    messages.next({
        cmd,
        data,
    });
};
export const sendSocketMessage = (type, payload) => {

    if (!socket) return;
    socket.emit(type, payload);
};

export const socketMessageStream = messages.asObservable();

export const updateSocketRef = (s) => (socket = s);



// WEBPACK FOOTER //
// ./src/utils/socketStream.js